import store from '@/store';

import Modules from './Modules.vue';
import Customers from './Customers.vue';
import Users from '../Settings/Users.vue';

export const initialView = 'customers';

export default {
  customers: {
    label: 'Clientes',
    component: Customers,
    async beforeEnter() {
      await store.dispatch('loadDashboardCustomers');
    },
  },
  modules: {
    label: 'Módulos',
    component: Modules,
    async beforeEnter() {
      await store.dispatch('loadDashboardModules');
    },
  },
  users: {
    label: 'Usuários globais',
    component: Users,
    async beforeEnter() {
      await store.dispatch('loadUsers', { global: true });
    },
    isEnabled(user) {
      return user?.role === 'admin';
    },
  },
};
